import React from "react";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import { PublicHeader } from "../PublicHeader";
import { PublicFooter } from "../PublicFooter";

export const PublicLayout = ({ children, headerRight }) => {
  const { clinic } = useParams();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", bgcolor: "#f5f5f5" }}>
      <PublicHeader rightContent={headerRight} clinicId={clinic} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
          py: 4,
        }}
      >
        {children}
      </Box>
      <PublicFooter />
    </Box>
  );
}
